module.exports = __webpack_public_path__ + "img/menus_03.27d404ea.png";